import { render, staticRenderFns } from "./ComptrollerReportV6.vue?vue&type=template&id=36c6dec9&scoped=true"
import script from "./ComptrollerReportV6.vue?vue&type=script&lang=js"
export * from "./ComptrollerReportV6.vue?vue&type=script&lang=js"
import style0 from "./ComptrollerReportV6.vue?vue&type=style&index=0&id=36c6dec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c6dec9",
  null
  
)

export default component.exports